import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (err) {
      setError('이메일 또는 비밀번호가 올바르지 않아요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.box}>
        <h1 style={styles.title}>너풀너풀 <em>studio</em></h1>
        <p style={styles.sub}>관리자 로그인</p>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="이메일"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--paper)',
  },
  box: {
    width: '100%',
    maxWidth: '360px',
    padding: '3rem 2rem',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'var(--serif)',
    fontSize: '2rem',
    fontWeight: 300,
    letterSpacing: '-.02em',
    color: 'var(--ink)',
    marginBottom: '.4rem',
  },
  sub: {
    fontFamily: 'var(--mono)',
    fontSize: '.6rem',
    letterSpacing: '.18em',
    textTransform: 'uppercase',
    color: 'var(--ink-soft)',
    marginBottom: '2.5rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.8rem',
  },
  input: {
    fontFamily: 'var(--serif)',
    fontSize: '.95rem',
    fontWeight: 300,
    color: 'var(--ink)',
    background: 'var(--paper-dim)',
    border: '1px solid var(--ink-pale)',
    borderRadius: '2px',
    padding: '.9rem 1.1rem',
    outline: 'none',
    width: '100%',
  },
  error: {
    fontFamily: 'var(--mono)',
    fontSize: '.6rem',
    letterSpacing: '.08em',
    color: '#c0392b',
    textAlign: 'left',
  },
  btn: {
    fontFamily: 'var(--mono)',
    fontSize: '.65rem',
    letterSpacing: '.16em',
    textTransform: 'uppercase',
    color: 'var(--paper)',
    background: 'var(--ink)',
    border: 'none',
    borderRadius: '2px',
    padding: '1rem',
    cursor: 'pointer',
    marginTop: '.4rem',
  },
};
